import { StyleSheet } from "react-native";

const shadow = StyleSheet.create({
  top: {
    elevation: 9,
    shadowColor: "#000",
    shadowOpacity: 0.01,
    shadowOffset: {
      width: 1,
      height: -1,
    },
  },
  bottom: {
    elevation: 2,
    shadowColor: "#000",
    shadowOpacity: 0.19,
    shadowOffset: {
      width: 0,
      height: 2,
    },
  },
  all: {
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 12,
    },
    shadowOpacity: 0.58,
    shadowRadius: 16.0,

    elevation: 24,
  },
});

export default shadow;
